import Marquee from "react-fast-marquee";

const ITEMS = ["MEDICAL COURIER", "DNA TESTING", "DRUG TESTING", "NOTARY SERVICES", "PHLEBOTOMY SOON"];

export const MarqueeStrip = () => (
  <section className="py-8 md:py-12 border-y border-border overflow-hidden bg-foreground">
    <Marquee speed={40} gradient={false}>
      {ITEMS.concat(ITEMS).map((t, i) => (
        <span key={i} className="font-display font-black text-5xl md:text-8xl tracking-tighter uppercase mx-8 text-background/10 [-webkit-text-stroke:1.5px_hsl(var(--background))]">
          {t}
          <span className="text-background/40 mx-8">◆</span>
        </span>
      ))}
    </Marquee>
  </section>
);
